export const LOGO_LIGHT = "/brand/logo.png";
export const LOGO_DARK = "/brand/logo.png";

export const deliveryOptions = [
  {
    id: "pickup",
    name: "Самовывоз",
    address: "Новосибирск, ул. Тимирязева, 70",
    price: 0
  },
  {
    id: "dostavista",
    name: "Доставка по Новосибирску (dostavista)",
    price: 300
  },
  {
    id: "cdek",
    name: "Доставка в другие города (СДЭК)",
    price: 400
  }
];

export const cities = [
  "Москва",
  "Санкт-Петербург",
  "Екатеринбург",
  "Казань",
  "Нижний Новгород",
  "Самара",
  "Омск",
  "Челябинск",
  "Ростов-на-Дону",
  "Уфа",
  "Красноярск",
  "Воронеж",
  "Пермь",
  "Волгоград"
];

export const orderStatuses = {
  new: "Новый",
  confirmed: "Подтверждён",
  processing: "В обработке",
  shipping: "В доставке",
  delivered: "Доставлен",
  cancelled: "Отменён"
};

export const footerContent = {
  telegram: "@tihelp_tgbot",
  telegramUrl: "https://t.me/tihelp_tgbot?start=start"
};
